import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { VizaData } from '@app/interfaces/VizaData';

@Injectable({ providedIn: 'root' })
export class ReservationService {

  constructor(private http: HttpClient) { }

  GetReservationInfo(guestStayUuId: string, invite?: string, lngCode?: string) {
    return this.http.get(environment.exiBackendUrl + "/api/exi/Reservation/GetReservationInfo/" + guestStayUuId + "/" + invite + "/" + lngCode)
  }

  GetTableGuestStayUuid(hotel3pId: string, device3pId: string) {
    return this.http.get(environment.exiBackendUrl + "/api/exi/Reservation/GetTableGuestStayUuid/" + hotel3pId + "/" + device3pId)
  }

  GetVipTableGuestDatas(hotel3pId: string, device3pId: string) {
    return this.http.get<VizaData>(environment.exiBackendUrl + "/api/exi/Reservation/GetVipTableGuestDatas/" + hotel3pId + "/" + device3pId)
  }

  getResNum(hote13pId: string, guestStayUuid: string) {
    let apiServer = environment.apiHost + environment.apiPort;
    return this.http.get(apiServer + '/api/exi/Reservation/GetGuestStayInfo/' + hote13pId + "/" + guestStayUuid);
  }

  // INFO: AType
  // 0-ismeretlen,
  // 1 Megrendelő,
  // 2 Számlaviselő,
  // 3 Előlegszámla
  getResAddress(hote13pId: string, resuuid: string) {
    let apiServer = environment.apiHost + environment.apiPort;
    return this.http.get(apiServer + '/api/exi/Reservation/GetResAddress/' + hote13pId + "/" + resuuid);
  }

  getGuestStayAddress(hote13pId: string, guestStayUuid: string) {
    let apiServer = environment.apiHost + environment.apiPort;
    return this.http.get(apiServer + '/api/exi/Reservation/GetGuestStayAddress/' + hote13pId + "/" + guestStayUuid);
  }

  getGuestStayInfo(hote13pId: string, guestStayUuid: string) {
    let apiServer = environment.apiHost + environment.apiPort;
    return this.http.get(apiServer + '/api/exi/Reservation/GetGuestStayInfo/' + hote13pId + "/" + guestStayUuid);
  }
}